let React    = require('react');
let ReactDom = require('react-dom');
let Utils    = require('utils');

// -------------------------------------------------------
// Auth0 設定
//   auth0Domain   : Auth0 テナントのドメイン (サーバーが AUTH0_DOMAIN から window.__DATA__ 経由で渡す)
//   auth0ClientId : Auth0 アプリケーションのクライアントID (同じくサーバーから渡される)
//   REDIRECT_URI  : Auth0 認証後のコールバックURL
// -------------------------------------------------------
const REDIRECT_URI = window.location.origin + '/login/callback';

// 画面右下に表示するバージョン
const APP_VERSION = 'v1.0.0';

// Auth0 Universal Login へリダイレクト
function redirectToAuth0(auth0Domain, auth0ClientId) {
  const params = new URLSearchParams({
    response_type : 'code',
    client_id     : auth0ClientId,
    redirect_uri  : REDIRECT_URI,
    scope         : 'openid profile email',
  });
  window.location.href = `https://${auth0Domain}/authorize?${params.toString()}`;
}
// -------------------------------------------------------

class Login extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { auth0Domain, auth0ClientId, inviteEmail } = this.props.data || {};

    if (Utils.default.cookieEnableCheck() !== true) {
      return (
        <div id="login">
          <div className="error-box">
            <p>ログインするためには、Cookieを有効にする必要があります。</p>
            <p>有効に変更後、<a href="/login">こちら</a>よりログインを行ってください。</p>
          </div>
        </div>
      );
    }

    return (
      <div id="login">
        <div className="login-box">
          <div className="login-logo" />

          <div className="box">
            {/* 変更案内 */}
            <div className="auth0-notice">
              <span className="material-icons notice-icon">{ inviteEmail ? 'mail' : 'info' }</span>
              { inviteEmail
                ? (
                  <React.Fragment>
                    <p className="notice-title">{inviteEmail} さんに招待が届いています</p>
                    <p className="notice-desc">
                      下記ボタンからログインして、招待を受け取ってください。
                    </p>
                  </React.Fragment>
                )
                : (
                  <React.Fragment>
                    <p className="notice-title">ログイン方式が変わりました</p>
                    <p className="notice-desc">
                      セキュリティ強化のため、認証を Auth0 へ移行しました。<br />
                      下記ボタンからログインしてください。
                    </p>
                  </React.Fragment>
                )
              }
            </div>

            {/* Auth0 ログインボタン */}
            <button className="auth0-login-button" onClick={() => redirectToAuth0(auth0Domain, auth0ClientId)}>
              <span className="material-icons">lock_open</span>
              ログイン
            </button>

            {/* 認証方法の案内 */}
            <div className="auth0-methods">
              <p className="methods-title">利用できる認証方法</p>
              <ul>
                <li>
                  <span className="material-icons method-icon">mail</span>
                  <span><strong>Gmail アカウント</strong> — Google でログインを選択</span>
                </li>
                <li>
                  <span className="material-icons method-icon">email</span>
                  <span><strong>メールアドレス ＋ パスワード</strong> — メールアドレスを入力してログイン</span>
                </li>
              </ul>
              <p className="methods-note">
                ※ 初回ログイン時はパスワード設定メールが届きます。<br />
                ※ パスワードを忘れた場合はログイン画面の「パスワードを忘れた場合」から再設定できます。
              </p>
            </div>

            <p className="login-version">{APP_VERSION}</p>
          </div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

export default Login;
